module.exports = __webpack_public_path__ + "img/qy (18).acd343c3.jpg";